import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LandingMetaService {
  private readonly document: Document = inject(DOCUMENT);
  private readonly metaTwitterUrl: HTMLMetaElement | null = this.document.querySelector('meta[property="twitter:url"]');
  private readonly base: HTMLBaseElement | null = this.document.querySelector('base');

  setTwitterUrl(url: string = ''): void {
    if (this.metaTwitterUrl) {
      this.metaTwitterUrl.setAttribute('content', url);
    }
  }

  setBase(url: string = ''): void {
    const lang = url?.split('fail/')[1]?.split('/')[0];

    if (lang && this.base) {
      if (!url.endsWith('landing')) {
        this.base.setAttribute('href', `/${lang}/`);
      } else {
        this.base.setAttribute('href', `/${lang}/landing`);
      }
    }
  }
}
